/**
 * POS-FULFILLMENT MODULE
 * Self-contained. Import only from /shared or within this module.
 * Do not import from other modules directly.
 */

// Route wrapper for the product-sample requests screen. Same auth adaptation as
// PosOrders: BC session → the source app-shaped { displayName, mail, username } user, a
// permission Set (.has), and onHome. Workspace owners/admins get edit/delete
// (the source app's `delete_sample_requests`); ordinary members submit requests only.
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSession } from "../../../shared/components/SessionProvider.jsx";
import { useWorkspaceAdmin } from "../../../shared/hooks/useWorkspaceAdmin.js";
import { displayName } from "../../../shared/utils/userDisplay.js";
import ProductSamplePage from "../components/ProductSamplePage.jsx";
import "../components/pos-tokens.css";

export default function SampleOrders() {
  const navigate = useNavigate();
  const { user } = useSession();
  const { isWorkspaceAdmin } = useWorkspaceAdmin();

  const shapedUser = useMemo(
    () => ({ displayName: displayName(user), mail: user?.email || "", username: user?.email || "" }),
    [user]
  );
  const userPermissions = useMemo(
    () => new Set(isWorkspaceAdmin ? ["delete_sample_requests"] : []),
    [isWorkspaceAdmin]
  );

  return (
    <div className="pos-module pos-dashboard">
      <ProductSamplePage user={shapedUser} userPermissions={userPermissions} onHome={() => navigate("/")} />
    </div>
  );
}
